import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { setItem } from 'api/actions';
import _ from 'lodash';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';
import moment from 'moment';
import * as actions from './actions';
import * as c from './constant';

const OrdinanceRevisionDropDown = ({
  getOrdinanceRevisionList,
  ordinanceRevisionList,
  selectedOption,
  pathName,
}) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(selectedOption);

  const effectivityOptions =
    ordinanceRevisionList.map((data) => {
      return {
        value: data.id,
        label: `${data.attributes.year_from} - ${
          data.attributes.year_to === +moment(new Date()).format('YYYY') + 1
            ? 'PRESENT'
            : data.attributes.year_to
        }`,
      };
    }) || {};
  const defaultFormValue = { year: effectivityOptions[0] };
  useEffect(() => {
    getOrdinanceRevisionList();
  }, []);

  useEffect(() => {
    dispatch(setItem(c.GET_FORMDATA_ORDINANCE_REVISION_RPT, formData));
  }, [formData]);

  useEffect(() => {
    localStorage.setItem(
      'formData',
      JSON.stringify(formData || defaultFormValue)
    );
    localStorage.setItem('defaultFormValue', JSON.stringify(defaultFormValue));
  }, [formData, defaultFormValue]);

  const handleChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e,
    });
  };

  const styles = {
    control: (base) => ({
      ...base,
      minHeight: 24,
      width: '200px',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
      color: '#7790CB',
      clipPath: 'polygon(50% 70%, 30%  35%, 70% 35%)',
      backgroundColor: '#7790CB',
    }),
    clearIndicator: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
  };

  return (
    <div className="dropdown-menu-container d-flex justify-content-end">
      {`${pathName.indexOf('land-settings/land-classification')}` > -1 ||
      `${pathName.indexOf('land-settings/rates')}` > -1 ||
      `${pathName.indexOf('land-settings/buv')}` > -1 ||
      `${pathName.indexOf('land-settings/assessment-level')}` > -1 ||
      `${pathName.indexOf('land-settings/adjustment-factor')}` > -1 ||
      `${pathName.indexOf('settings/building-kinds')}` > -1 ||
      `${pathName.indexOf('settings/assessment-levels')}` > -1 ||
      `${pathName.indexOf('settings/building-components')}` > -1 ||
      `${pathName.indexOf('settings/depreciation-rates')}` > -1 ||
      `${pathName.indexOf('settings/penalties')}` > -1 ? (
        <>
          <label
            className="dropdown-menu-title mr-2 my-auto cms-text-primary"
            style={{ color: '#4C6085' }}
          >
            <b>YEAR</b>
          </label>
          <Select
            styles={styles}
            placeholder="Select year"
            value={
              _.isEmpty(_.get(formData, 'year'))
                ? _.get(defaultFormValue, 'year')
                : _.get(formData, 'year')
            }
            options={effectivityOptions}
            onChange={handleChangeSelect('year')}
          />
        </>
      ) : (
        ''
      )}
    </div>
  );
};

OrdinanceRevisionDropDown.defaultProps = {
  selectedOption: {},
};

OrdinanceRevisionDropDown.propTypes = {
  ordinanceRevisionList: PropTypes.instanceOf(Object).isRequired,
  selectedOption: PropTypes.instanceOf(Object),
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => {
  // get the selected value from lower components (ex: NewTaxRevenuesLicense)
  const fetchSelectedOption = () => {
    try {
      return JSON.parse(localStorage.getItem('formData'));
    } catch (err) {
      return {};
    }
  };

  return {
    selectedOption: fetchSelectedOption(),
    ordinanceRevisionList: _.get(api, `${c.GET_ORDINANCE_REVISION}.list`) || [],
  };
};

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(OrdinanceRevisionDropDown);
